import React from 'react';
import ReactCountryFlag from "react-country-flag";
import TechIcon from '../../Utils/Icons/Icons';

const CountrySelector = ({ 
  selectedCountry, 
  dropdownOpen, 
  setDropdownOpen, 
  displayCountries, 
  handleCountrySelect, 
  showAllCountries, 
  setShowAllCountries 
}) => {
  return (
    <div className="phoneInputGroup">
      <div
        className="countrySelect"
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <ReactCountryFlag
          svg
          countryCode={selectedCountry.code}
          style={{ width: "1.1em", height: "1.1em" }}
        />
        <span className="countryName">{selectedCountry.name}</span>
        <span className="countryDial">({selectedCountry.dial})</span>
        <TechIcon
          name={dropdownOpen ? "chevron-up" : "chevron-down"}
          size={16}
        />
      </div>

      {dropdownOpen && (
        <div className="countryDropdown">
          <ul>
            {displayCountries.map((country) => (
              <li
                key={country.code}
                onClick={() => handleCountrySelect(country)}
              >
                <ReactCountryFlag
                  svg
                  countryCode={country.code}
                  style={{ width: "1.1em", height: "1.1em" }}
                />
                <span>
                  {country.name} ({country.dial})
                </span>
              </li>
            ))}
          </ul>

          {!showAllCountries && (
            <button
              type="button"
              className="moreCountriesBtn"
              onClick={(e) => {
                e.stopPropagation();
                setShowAllCountries(true);
              }}
            >
              Show all countries
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default CountrySelector;